module.exports = __webpack_public_path__ + "img/SCC_CD8Tex.e0813849.png";